import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    laboratorios: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_LABORATORIOS = 'GET_ALL_LABORATORIOS'
const INSERT_LABORATORIO = 'INSERT_LABORATORIO'
const ACTUALIZAR_LABORATORIO = 'ACTUALIZAR_LABORATORIO'
const DELETE_LABORATORIO = 'DELETE_LABORATORIO'

//*******************************************************************************************************************


//METODOS
export const obtenerLaboratorios = createAsyncThunk(
    GET_ALL_LABORATORIOS,
    async () => {
        try {
            const fullUrl = host + `Laboratorio/obtenerLaboratorios`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarLaboratorio = createAsyncThunk(
    INSERT_LABORATORIO,
    async (data) => {
        try {
            const fullUrl = host + `Laboratorio/agregarLaboratorio`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarLaboratorio = createAsyncThunk(
    ACTUALIZAR_LABORATORIO,
    async (data) => {
        try {
            const fullUrl = host + `Laboratorio/actualizarLaboratorio`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarLaboratorio = createAsyncThunk(
    DELETE_LABORATORIO,
    async (idlaboratorio) => {
        try {
            const fullUrl = host + `Laboratorio/eliminarLaboratorio/${idlaboratorio}`
            //alert(JSON.stringify(data))
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosLaboratoriosSlice = createSlice({

    name: 'metodosLaboratoriosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerLaboratorios.fulfilled]: (state, { payload }) => {
            state.asociadolocalidad = payload.data.data
        },
        [agregarLaboratorio.fulfilled]: (state, { payload }) => {
        },
        [actualizarLaboratorio.fulfilled]: (state, { payload }) => {
        },
        [eliminarLaboratorio.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosLaboratoriosSlice.actions
export const LaboratorioReducer = metodosLaboratoriosSlice.reducer